/*
SaiKrishna 10/06/2022 2698403495 Removed unnecessary console.log statements
*/
// const hostName = window.location.hostname;

module.exports = require('../config');
